import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'
import { LEGAL_PAGES } from '../data/meta'

export default function RefundPolicy() {
  const page = LEGAL_PAGES.refund
  return (
    <>
      <SEO title={page.title} description={page.description} canonical={page.url} structuredData={{ '@context': 'https://schema.org', '@type': 'WebPage', name: page.title, description: page.description }} />
      <Navbar />
      <div className="legal-page">
        <div className="legal-page-content">
          <h1>Refund Policy</h1>
          <p>Last updated: July 2026</p>

          <h2>1. Eligibility</h2>
          <p>
            Subscriptions are billed monthly or annually. Refunds are available within 14 days of purchase if the service is materially defective.
          </p>

          <h2>2. Cancellation Effects</h2>
          <p>
            Cancelling stops future billing. You retain access until the end of the current period. No prorated refunds are issued for partial months.
          </p>

          <h2>3. Razorpay Disputes</h2>
          <p>
            Chargebacks must be raised through Razorpay directly. We will assist with evidence submission within 7 business days.
          </p>

          <h2>4. Non-Refundable Items</h2>
          <p>
            Setup fees, add-on services, and custom integrations are non-refundable once provisioned.
          </p>

          <h2>5. Contact</h2>
          <p>
            Refund requests: support@tredextechnology.in or business@tredextechnology.in
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}
